export const allProducts = "/car/get-all-cars-admin"; //doubt
export const addProducts = "/car";
export const allBrands = "/brand/find-all";
export const productFindById = "/car";
export const allCategory = "/category/find-all";
export const findAllLocation = "/location/find-all";
export const addNewLocation = "/location/create";
export const editProduct = "/car";
export const deleteProduct = "/car";
export const getAllCarsAdmin = "/car/get-all-cars-admin";
export const markAsSold = "/car/mark-as-sold";
